import Rubik from "@assets/fonts/Rubik/static/Rubik-Regular.ttf";
import RubikMedium from "@assets/fonts/Rubik/static/Rubik-Medium.ttf";
import RubikSemiBold from "@assets/fonts/Rubik/static/Rubik-SemiBold.ttf";

interface Font {
  url: typeof Rubik;
  weight: string;
  local: string;
}
const fonts: Font[] = [
  { url: Rubik, weight: "400", local: "Rubik-Regular" },
  { url: RubikMedium, weight: "500", local: "Rubik-Medium" },
  { url: RubikSemiBold, weight: "600", local: "Rubik-SemiBold" },
];

const getFontFace = (font: Font) => `
@font-face {
  font-family: 'Rubik';
  font-style: normal;
  font-display: swap;
  font-weight: ${font.weight};
  src: local('Rubik'), local('${font.local}'), url(${font.url}) format('truetype');
  unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
}
`;

const getFontFaces = () => fonts.map((font) => getFontFace(font)).join("\n");

export default getFontFaces();
